import {
    FETCH_MENTAL_WELLNESS_BEGIN,
    FETCH_MENTAL_WELLNESS_SUCCESS,
    FETCH_MENTAL_WELLNESS_FAILED,
  } from "../actions/mentalWellnessActions";

  const initialState = {
    data: {},
    fetching: false,
    error: null,
  };

  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MENTAL_WELLNESS_BEGIN:
        return { ...state, fetching: true };
      case FETCH_MENTAL_WELLNESS_FAILED:
        return { ...state, fetching: false, error: action.payload };
      case FETCH_MENTAL_WELLNESS_SUCCESS:
        return {
          ...state,
          fetching: false,
          data: action.payload,
        };
      default:
        return state;
    }
  };



// WEBPACK FOOTER //
// ./reducers/mentalWellnessReducer.js